import * as Types from "../constants/Role";
import { ViewState } from "redux/constants/App";
import { setBusy, setError, setReady } from "./utils";

const initialState = {
    roles: [],
    error: {
        status: null,
        message: null,
        errors: [],
    },
    role: {
        id: null,
        name: null,
        description: null,
    },
    postStatus: ViewState.IDLE,
    getStatus: ViewState.IDLE,
    getIdStatus: ViewState.IDLE,
    tablePath: '/admin/role'
}

const actions = {

    [Types.ADD_ROLE]: (state) => setBusy({ state, statusKey: "postStatus" }),
    [Types.ADD_ROLE_OK]: (state) => setReady({ state, statusKey: "postStatus" }),
    [Types.ADD_ROLE_FAILED]: (state, error) => setError({ state, statusKey: "postStatus", error }),

    [Types.FETCH_ROLES]: (state) => setBusy({ state, statusKey: "getStatus" }),
    [Types.FETCH_ROLES_FAILED]: (state, error) => setError({ state, statusKey: "getStatus", error }),
    [Types.FETCH_ROLES_OK]: (state, roles) => setReady({ state, statusKey: "getStatus", payload: { roles } }),

    [Types.FETCH_ROLE_ID]: (state) => setBusy({ state, statusKey: "getIdStatus" }),
    [Types.FETCH_ROLE_ID_FAILED]: (state, err) => setError({ state, statusKey: "getIdStatus", error: err }),
    [Types.FETCH_ROLE_ID_OK]: (state, role) => setReady({ state, statusKey: "getIdStatus", payload: { role } }),

    [Types.PATCH_ROLE]: (state) => setBusy({ state, statusKey: "postStatus" }),
    [Types.PATCH_ROLE_OK]: (state) => setReady({ state, statusKey: "postStatus" }),
    [Types.PATCH_ROLE_FAILED]: (state, error) => setError({ state, statusKey: "postStatus", error }),
    
    [Types.RESET_ROLE]: (_) => Object.assign({}, initialState)
}

export default function (state = initialState, { type: actionType, payload }) {
    const action = actions[actionType];
    if (action) return action(state, payload);
    return state;
}